
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

if (environment.production) {
  //disable console display
  window.console.log = function() { /* noop */ };
  window.console.warn = function() { /* noop */ };
  window.console.info = function() { /* noop */ };
  window.console.debug = function() { /* noop */ };
  window.console.error = function() { /* noop */ };
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
